import state from './moduleBasicState.js';
import mutations from './moduleBasicMutations.js';
import actions from './moduleBasicActions.js';
import getters from './moduleBasicGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
